// export const LocalStore = {
//     isLogin: () =>{
//         let data = localStorage.getItem("data");
//         if(data != null) return true;
//         else return false;
//     },
//     doLogin: (data, next) => {
//         const {user,...restItem} = data;
//         localStorage.setItem("data", JSON.stringify(restItem));
//         localStorage.setItem('isUser', JSON.stringify({status: true, user: user}));
//         return true;
//     },
//     doLogout: () => {
//         localStorage.removeItem("data");
//         localStorage.removeItem("isUser");
//         localStorage.removeItem("userListGridState");
//         window.location.href = "/login"; // Redirect to /login page
//         return true;
//     },
//     getCurrentUserDetails: () => {
//         if(LocalStore.isLogin){
//             return JSON.parse(localStorage.getItem("data"));
//         }else{
//             window.location.href = "/login";
//             return false;
//         }
//     },
//     getLoggedUserDetails: () => {
//         if(LocalStore.isLogin){
//             console.log("User is logged in:",LocalStore.isLogin);
//             console.log("getLoggedUserDetails");
//             return JSON.parse(localStorage.getItem("isUser"))?.user;
//         }else{
//             window.location.href = "/login";
//             return false;
//         }
//     }

// }; 

export const loginRedirectPath = (data, storedLastVisitedInfo) => {
    try {
        const lastVisitedInfo = storedLastVisitedInfo ? JSON.parse(storedLastVisitedInfo) : null;
        if (data.id === lastVisitedInfo?.id
            && data.role === lastVisitedInfo?.role
            && lastVisitedInfo?.lastVisitedUrl
            && lastVisitedInfo.lastVisitedUrl !== "/login") {
            return lastVisitedInfo.lastVisitedUrl;
        }
    } catch {
        // Ignore malformed stale browser storage and use the safe default route.
    }
    return "/admin";
};

export const LocalStore = {
    isLogin: () => {
        let data = localStorage.getItem("data");
        if(data != null) return true;
        else return false;
    },
    doLogin: (data, next) => {
        const {user, ...restItem} = data;
        localStorage.setItem("data", JSON.stringify(restItem));
        localStorage.setItem('isUser', JSON.stringify({status: true, user: user}));
        const redirectPath = loginRedirectPath(data, localStorage.getItem("lastVisitedInfo"));
        localStorage.removeItem("lastVisitedInfo");
        window.location.href = redirectPath;
        return true;
    },
    doLogout: () => {
        const currentUrl = window.location.pathname + window.location.search;
        const loggedUserDetails =LocalStore.getCurrentUserDetails();
        // logged user id and last visited url store in local storage
        const lastLoggedDetails = {
            id:loggedUserDetails.id,
            role:loggedUserDetails.role,
            lastVisitedUrl: currentUrl
        }
        localStorage.setItem("lastVisitedInfo", JSON.stringify(lastLoggedDetails));
        
        localStorage.removeItem("data");
        localStorage.removeItem("isUser");
        localStorage.removeItem("userListGridState");
        window.location.href = "/login"; // Redirect to /login page
        return true;
    },
    getCurrentUserDetails: () => {
        if(LocalStore.isLogin()){ // Fixed: Added parentheses to call the function
            return JSON.parse(localStorage.getItem("data"));
        } else {
            window.location.href = "/login";
            return false;
        }
    },
    getLoggedUserDetails: () => {
        if(LocalStore.isLogin()){ 
            return JSON.parse(localStorage.getItem("isUser"))?.user;
        } else {
            window.location.href = "/login";
            return false;
        }
    }
};
